import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

export type FunctionGroupTone = 'success' | 'danger' | 'info';

const TITLE_CLASS: Record<FunctionGroupTone, string> = {
  success: 'text-green text-sm font-semibold',
  danger: 'text-red text-sm font-semibold',
  info: 'text-blue text-sm font-semibold',
};

const CHIP_BASE_CLASS =
  'my-1 mr-1.5 inline-flex items-center gap-1.5 rounded-md border px-3 py-2 text-sm';

const CHIP_CLASS: Record<FunctionGroupTone, string> = {
  success: `${CHIP_BASE_CLASS} border-green-700 bg-green-900 text-green-200`,
  danger: `${CHIP_BASE_CLASS} border-red-800 bg-red-950 text-red-200`,
  info: `${CHIP_BASE_CLASS} border-blue-700 bg-blue-950 text-blue-200`,
};

@Component({
  selector: 'app-coverage-function-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  templateUrl: './coverage-function-group.component.html',
})
export class CoverageFunctionGroupComponent {
  readonly titleKey = input.required<string>();
  readonly hintKey = input.required<string>();
  readonly functionNames = input.required<string[]>();
  readonly tone = input.required<FunctionGroupTone>();
  readonly symbol = input.required<string>();

  protected readonly count = computed(() => this.functionNames().length);
  protected readonly titleClass = computed(() => TITLE_CLASS[this.tone()]);
  protected readonly chipClass = computed(() => CHIP_CLASS[this.tone()]);
}
